export default __webpack_public_path__ + "static/media/Slide-2.df7d3a2d.png";